import type { SVGProps } from "react";

export const MFAGuardianIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14px"
    height="18px"
    viewBox="0 0 14 18"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#757575"
      d="M6.5,4 L6.5,1 C6.5,0.723857625 6.72385763,0.5 7,0.5 C7.27614237,0.5 7.5,0.723857625 7.5,1 L7.5,4 L7.5,5 L9.5,5 L9.5,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,17 C14,17.5522847 13.5522847,18 13,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,5 C0,4.44771525 0.44771525,4 1,4 L4.5,4 L4.5,5 L6.5,5 L6.5,4 Z M7.5,5 L7.5,12.2928932 L9.64644661,10.1464466 C9.84170876,9.95118446 10.1582912,9.95118446 10.3535534,10.1464466 C10.5488155,10.3417088 10.5488155,10.6582912 10.3535534,10.8535534 L7.35355339,13.8535534 C7.15829124,14.0488155 6.84170876,14.0488155 6.64644661,13.8535534 L3.64644661,10.8535534 C3.45118446,10.6582912 3.45118446,10.3417088 3.64644661,10.1464466 C3.84170876,9.95118446 4.15829124,9.95118446 4.35355339,10.1464466 L6.5,12.2928932 L6.5,5 L1,5 L1,17 L13,17 L13,5 L7.5,5 Z"
    />
  </svg>
);
